class VolumePrice extends HTMLElement {
  constructor() {
    super();
  }
  updateState(quantity) {
    let highest = -1;
    document.querySelectorAll('volume-price').forEach(node => {
      if(node.hasAttribute('quantity')) {
        const node_quantity = Number(node.getAttribute('quantity'));
        if(quantity >= node_quantity && node_quantity > highest) {
          highest = node_quantity;
        }
      }
    });
    if(highest === this.quantity) {
      this.check();
    }
  }
  check() {
    if(this.hasAttribute('checked'))
      return;
    // uncheck other scale prices and check this one
    const allInstances = document.querySelectorAll('volume-price');
    allInstances.forEach(instance => {
      instance.removeAttribute('checked');
    })
    this.setAttribute('checked', '');

    this.dispatchEvent(new CustomEvent('product:volume-price:updated', {
      bubbles: true,
      detail: {
        quantity: this.quantity,
        price: this.price
      }
    }));
  }
  handleClick() {
    this.check();
    // set quantity to the current volume price quantity
    const quantityInput = this.closest('[data-product-info]')?.querySelector('form[data-product-form] input[name="quantity"]');
    if(quantityInput && this.quantity) {
      quantityInput.value = this.quantity;
      quantityInput.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
    }
  }
  setQuantityListener() {
    const quantityInput = this.closest('[data-product-info]')?.querySelector('form[data-product-form] input[name="quantity"]');
    quantityInput?.addEventListener('change', e => {
      this.updateState(quantityInput.value);
    });
    this.updateState(quantityInput.value);
  };
  connectedCallback() {
    this.quantity = this.hasAttribute('quantity') ? Number(this.getAttribute('quantity')) : null;
    this.price = this.hasAttribute('price') ? Number(this.getAttribute('price')) : null;
    this.addEventListener('click', e => {
      if(!this.hasAttribute('checked')) {
        this.handleClick();
      }
    });
    this.setQuantityListener();
  }
}
if ("customElements" in window && !customElements.get("volume-price")) {
  customElements.define("volume-price", VolumePrice);
}